/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Waypoint } from 'react-waypoint';
import { func, node, bool } from 'prop-types';

const HOCList = ({ onEnter, onLeave, isLoadMore, children }) => {
  return (
    <>
      {children}
      {isLoadMore && (
        <Waypoint onEnter={onEnter} onLeave={onLeave}>
          <div className="text-center">
            <Icon name="spinner" loading size="big" />
          </div>
        </Waypoint>
      )}
    </>
  );
};

HOCList.propTypes = {
  isLoadMore: bool,
  onEnter: func,
  onLeave: func,
  children: node,
};

HOCList.defaultProps = {
  isLoadMore: false,
  onEnter: () => {},
  onLeave: () => {},
  children: null,
};

export default HOCList;
